import React from "react";
import MicroFrontend from "./micro-frontend";
import {UrlExtractor} from "./util/UrlExtractor";
import PicData from "./entity/PicData";
import { AppPlatform } from ".";

interface PicModuleLoaderProps {
  history?: any;
  data?: PicData;
}

const PicModuleLoader = ({history, data}: PicModuleLoaderProps) => {
  const moduleName = "PicModule";

  const emptyData = {} as PicData;
  data = (data || emptyData);

  let cloudFrontUrl;


  if (data.platform === AppPlatform.ASH) {
    //Setting up auth token for ASH
    const token = window.localStorage.getItem('accessToken');
    data.token = token;
    cloudFrontUrl = UrlExtractor.getASHCloudFrontUrl();
    data.apiEndpoint = UrlExtractor.getASHApiGatewayUrl();
  } else {
    cloudFrontUrl = UrlExtractor.getCloudFrontUrl();
    // Inject api gateway url
    data.apiEndpoint = UrlExtractor.getApiGatewayUrl();
  }

  return (
    <MicroFrontend
      name={moduleName}
      history={history}
      data={data}
      cloudFrontUrl={cloudFrontUrl}
    />
  );
};

export default PicModuleLoader;
